import config from "../config.json"

export const images = {
  getLogo() {
    return `${config.apiUrl}images/general/header/?ws_key=${config.apiKey}`;
  },

  productImage(productId, imageId) {
    return `${config.apiUrl}images/products/${productId}/${imageId}/?ws_key=${config.apiKey}`
  },

  categoryImage(id) {
    return `${config.apiUrl}images/categories/${id}?ws_key=${config.apiKey}`
  },

  getManufacturersImg(id) {
    return `${config.apiUrl}images/manufacturers/${id}/?ws_key=${config.apiKey}`
  },
  
  getEventsImg(id) {
    return `${config.apiUrl}images/events_${id}/?ws_key=${config.apiKey}`
  }
}


// WEBPACK FOOTER //
// ./src/utils/images/index.js